/**
 * Layout API client
 * Fetches layout data from Umbraco CMS
 */

import { getEnv } from "@/config/env";
import { getJson, withCacheBust } from "@/api/http";
import type { LayoutPayload, Result } from "@/types/layout";

const LAYOUT_ENDPOINT = "/layout";

/**
 * Fetches the layout configuration from Umbraco.
 *
 * The layout carries per-user auth state and the backend now returns it with
 * `Cache-Control: no-store`, so no client-side cache busting is needed for
 * login changes. `withCacheBust` only applies in preview mode.
 * @param signal - Optional AbortSignal
 */
export async function fetchLayout(
  signal?: AbortSignal
): Promise<Result<LayoutPayload>> {
  const env = getEnv();
  const url = withCacheBust(`${env.apiBaseUrl}${LAYOUT_ENDPOINT}`);
  return getJson<LayoutPayload>(url, signal ? { signal } : undefined);
}
